import { render } from "./DCCsSelector.vue?vue&type=template&id=23e60144"
import script from "./DCCsSelector.vue?vue&type=script&lang=js"
export * from "./DCCsSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DCCsSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23e60144"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23e60144', __exports__)) {
    api.reload('23e60144', __exports__)
  }
  
  module.hot.accept("./DCCsSelector.vue?vue&type=template&id=23e60144", () => {
    api.rerender('23e60144', render)
  })

}


export default __exports__